import { render, staticRenderFns } from "./AccueilEnfants.vue?vue&type=template&id=8bbe9cda&scoped=true&"
import script from "./AccueilEnfants.vue?vue&type=script&lang=ts&"
export * from "./AccueilEnfants.vue?vue&type=script&lang=ts&"
import style0 from "./AccueilEnfants.vue?vue&type=style&index=0&id=8bbe9cda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbe9cda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
